import Axios from 'axios';

Axios.defaults.baseURL = 'https://abc.com/api';

export const axiosInstance = Axios.create({});
